import { render } from "./kalio-number-range-input.vue?vue&type=template&id=d2ac1284"
import script from "./kalio-number-range-input.vue?vue&type=script&lang=js"
export * from "./kalio-number-range-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__